import React, { useContext } from 'react'
import styled from 'styled-components'

import { default as Docs } from './FormalityDocs'
import { default as Notes } from './Form/InternalNotes'
import FormalityProgressStatus from './FormalityProgressStatus'
import FormalityResume from './FormalityResume'
import FormalityAbortBtn from './FormalityAbortBtn'
import FormNew from './Form'
import FormalityActions from './FormalityActions'
import FormalityRollbackBtn from './FormalityRollbackBtn'
import FormalityReloadDocumentsBtn from './FormalityReloadDocumentsBtn'
import FormalityActionsMenu from './FormalityActionsMenu'
import FormalityTags from './FormalityTags'

import {
  FormalityAbortWrapper,
  FormalityBox as Box,
  FormalityHeader,
} from './styles'
import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import { AbilityContext } from 'contexts/abilityContext'

const LegalFormality = () => {
  const { legalFormality, currentTab, setCurrentTab } = useContext(
    CurrentLegalFormalityContext
  )
  const ability: any = useContext(AbilityContext)
  const formalistOnly = ability.can('update', 'LegalFormality')

  return (
    <>
      <Box>
        <FormalityHeader>
          <FormalityResume />
          <FormalityProgressStatus />
        </FormalityHeader>
        {legalFormality.tags && legalFormality.tags.length > 0 && (
          <FormalityTags />
        )}
      </Box>

      <TabButtons>
        <TabButton
          active={currentTab === 'form'}
          onClick={() => setCurrentTab('form')}
        >
          Formulaire
        </TabButton>
        <TabButton
          active={currentTab === 'docs'}
          onClick={() => setCurrentTab('docs')}
        >
          Documents
        </TabButton>
        <TabButton className={'float-right icon'}>
          <FormalityActionsMenu />
        </TabButton>
      </TabButtons>

      {currentTab == 'form' && (
        <Box>
          <Panes>
            <Pane width={'50%'}>
              <FormNew />
            </Pane>

            <Pane>
              <Notes />
            </Pane>
          </Panes>
          <FormalityActions />
        </Box>
      )}

      {currentTab == 'docs' && (
        <Box>
          <Docs />
          <FormalityActions />
        </Box>
      )}

      {formalistOnly && (
        <FormalityAbortWrapper>
          <FormalityReloadDocumentsBtn />
          <FormalityRollbackBtn />
          <FormalityAbortBtn />
        </FormalityAbortWrapper>
      )}
    </>
  )
}

const TabButtons = styled.div`
  margin-bottom: 16px;
`

const TabButton = styled.a`
  font-weight: 700;
  font-size: 20px;
  color: ${props => (props.active ? '#171a1c' : '#92979c')};
  &:not(:last-child) {
    margin-right: 24px;
  }
  &.float-right {
    float: right;
  }
`

const Panes = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 16px;
  align-content: space-between;
  align-items: stretch;
`

const Pane = styled(Box)`
  ${props => (props.width ? `width: ${props.width};` : '')}
  flex-shrink: 1;
  flex-grow: 1;
`

export default LegalFormality
